import { useEffect, useRef } from 'react';
import { track } from '../services/analytics';

/**
 * Fire `empty_state_viewed` exactly once per page-mount when a list page
 * finishes loading with zero rows. Lets you measure "how many active owners
 * have 0 leads / 0 tenants / 0 payments?" — a strong churn-risk signal.
 *
 * @param {string} pageName — e.g. 'tenants', 'leads', 'collections'
 * @param {number} count   — current row count
 * @param {boolean} loading — page's loading flag (skip while true)
 */
export const useEmptyStateTracker = (pageName, count, loading) => {
  const firedRef = useRef(false);
  useEffect(() => {
    if (loading || firedRef.current) return;
    if (count === 0) {
      firedRef.current = true;
      track('empty_state_viewed', { page: pageName });
    }
  }, [pageName, count, loading]);
};
